/* Список магазинов для показа баннера */
export const CALL_ME_BANNER_ALLOWED_SLUGS: string[] = [
    'kit14874',
    'kit26140',
    'kit6977',
    'kit23410',
    'kit24945',
    'kit12433',
    'kit21386',
    'kit14763',
    'kit7985',
    'kit14380',
    'kit6121',
    'kit26118',
    'kit21769',
    'kit21788',
    'kit16187',
    'kit22475',
    'kit22179',
    'kit26213',
    'kit21926',
    'kit21288',
    'kit26050',
    'kit20364',
    'kit24482',
    'kit3330',
    'kit25462',
    'kit15760',
    'kit25793',
    'kit7333',
    'kit7203',
    'kit23256',
    'kit1728',
    'kit11422',
    'kit16667',
    'kit26120',
    'kit23787',
    'kit2074',
    'kit6414',
    'kit3138',
    'kit7620',
    'kit7728',
    'kit8838',
    'kit1692',
    'kit26392',
    'kit15577',
    'kit7729',
    'kit21448',
    'kit7603',
    'kit22853',
    'kit5984',
    'kit6848',
    'kit24319',
    'kit22429',
    'kit11093',
    'kit10669',
    'kit10845',
    'kit17529',
    'kit13842',
    'kit9005',
    'kit23651',
    'kit26199',
    'kit21023',
    'kit21902',
    'kit24737',
    'kit15604',
    'kit27698',
    'kit23387',
    'kit27483',
    'kit6929',
    'kit8197',
    'kit27409',
    'kit8576',
    'kit3715',
    'kit15575',
    'kit27619',
    'kit25427',
    'kit20097',
    'kit26112',
    'kit22834',
    'kit2508',
    'kit6903',
    'kit28245',
    'kit24966',
    'kit4118',
    'kit12711',
    'kit22555',
    'kit3657',
    'kit25392',
    'kit18419',
    'kit4691',
    'kit18949',
    'kit21141',
    'kit23930',
    'kit18098',
    'kit19775',
    'kit6960',
    'kit7638',
    'kit24900',
    'kit5379',
    'kit19057',
    'kit1392',
    'kit1139',
    'kit19211',
    'kit22375',
    'kit25420',
    'kit28250',
    'kit11311',
    'kit17825',
    'kit19974',
    'kit12478',
    'kit20004',
    'kit21166',
    'kit11271',
    'kit14470',
    'kit1665',
    'kit9436',
    'kit17443',
    'kit12534',
    'kit7057',
    'kit10543',
    'kit21742',
    'kit28119',
    'kit11399',
    'kit8123',
    'kit23390',
    'kit7442',
    'kit18148',
    'kit26742',
    'kit21745',
    'kit4751',
    'kit18666',
    'kit14417',
    'kit23461',
    'kit25015',
    'kit22232',
    'kit15326',
    'kit11665',
    'kit23458',
    'kit22427',
    'kit15641',
    'kit26741',
    'kit5129',
    'kit27269',
    'kit27625',
    'kit26224',
    'kit26931',
    'kit15497',
    'kit25276',
    'kit25939',
    'kit27981',
    'kit7245',
    'kit22589',
    'kit8138',
    'kit21855',
    'kit21417',
    'kit16857',
    'kit10353',
    'kit26800',
    'kit3446',
    'kit15777',
    'kit11154',
    'kit8209',
    'kit22845',
    'kit16817',
    'kit22943',
    'kit2064',
    'kit7718',
    'kit8750',
    'kit4636',
    'kit11823',
    'kit8038',
    'kit3880',
    'kit18420',
    'kit20702',
    'kit22473',
    'kit25513',
    'kit15857',
    'kit21608',
    'kit24969',
    'kit1054',
    'kit27546',
    'kit26844',
    'kit1385',
    'kit22075',
    'kit21056',
    'kit10663',
    'kit20008',
    'kit1527',
    'kit23223',
    'kit4234',
    'kit7070',
    'kit27006',
    'kit26554',
    'kit18288',
    'kit15805',
    'kit27284',
    'kit26865',
    'kit24820',
    'kit27296',
    'kit22057',
    'kit27243',
    'kit21319',
    'kit7637',
    'kit18641',
    'kit19032',
    'kit27085',
];

export const SLUG_MACROS = '{slug}';

export const CALL_ME_BANNER_FORM_URL = `https://forms.yandex.ru/surveys/13827491.e50d5c88903f0f8aea271816fc7b7609bb0f1777/?utm_source=lk&utm_medium=free&utm_content=inv-own__snd-kit__fmt-messenger__ecom&utm_campaign=dept-mrkt__svc-kit__aud-b2b__msg-promo__potential_clients&answer_choices_9008970581178818=9008970581178828&answer_short_text_9008970580571468=https://${SLUG_MACROS}.b2b.kit.yandex.ru`;

export const CALL_ME_BANNER_START_TIME = 0;

const endDate = new Date(2026, 7, 1); // 01 августа 2026

export const CALL_ME_BANNER_END_TIME = endDate.getTime();
